import React from "react";
import "../_css/Home.css";
import Index from "../_components/Home/Index";

const Home = () => {
  return <Index />;
};

export default Home;
